import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/sales-order/{id}/receive-payment`。INVOICED → PAID。body：`updatedAt`。 */
export async function receiveSalesOrderPayment(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/sales-order/${id}/receive-payment`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
